import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@nextiva/engagement-ui';
import cx from 'classnames';
import InlineButton from '../../InlineButton';
import { SMALL, MEDIUM, LARGE } from '../constants/headerLogoImageSizePresets';

import {
  getActiveSectionHeaderLogoImageLinkUrl,
  getActiveSectionHeaderLogoImageSizePreset,
} from '../../../reducers';
import {
  clearHeaderLogoImage,
  openInsertHeaderLogoImageModal,
  openInsertHeaderLogoLinkModal,
} from '../../../actions/headerEditorActions';

import styles from './HeaderImageToolbar.scss';

class HeaderImageToolbar extends Component {
  static propTypes = {
    onUploadImage: PropTypes.func.isRequired,
    onRemoveImage: PropTypes.func.isRequired,
    openInsertHeaderLogoLinkModal: PropTypes.func.isRequired,
    className: PropTypes.string,
    url: PropTypes.string,
    sizePreset: PropTypes.string.isRequired,
    onChangePreset: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    isAddLinkSelected: false,
    url: null,
  };

  onSmallClickHandler = () => this.props.onChangePreset(SMALL);
  onMediumClickHandler = () => this.props.onChangePreset(MEDIUM);
  onLargeClickHandler = () => this.props.onChangePreset(LARGE);

  onInsertImageLink = () =>
    this.props.openInsertHeaderLogoLinkModal(this.props.url);

  render() {
    const {
      onUploadImage,
      onRemoveImage,
      className,
      url,
      sizePreset,
    } = this.props;

    return (
      <div className={cx(styles.container, className)}>
        <div className={styles.group}>
          <Tooltip text="Small">
            <div
              className={cx(styles.item, {
                [styles.itemSelected]: sizePreset === SMALL,
              })}
              onClick={this.onSmallClickHandler}
            >
              <InlineButton
                className={styles.ico}
                iconClassName={cx(
                  'icon-custom-image-placeholder',
                  styles.smallIco,
                )}
              />
            </div>
          </Tooltip>
          <Tooltip text="Medium">
            <div
              className={cx(styles.item, {
                [styles.itemSelected]: sizePreset === MEDIUM,
              })}
              onClick={this.onMediumClickHandler}
            >
              <InlineButton
                className={styles.ico}
                iconClassName={cx(
                  'icon-custom-image-placeholder',
                  styles.mediumIco,
                )}
              />
            </div>
          </Tooltip>
          <Tooltip text="Large">
            <div
              className={cx(styles.item, {
                [styles.itemSelected]: sizePreset === LARGE,
              })}
              onClick={this.onLargeClickHandler}
            >
              <InlineButton
                className={styles.ico}
                iconClassName="icon-custom-image-placeholder"
              />
            </div>
          </Tooltip>
        </div>
        <div className={styles.group}>
          <Tooltip text="Add link">
            <div
              className={cx(styles.item, {
                [styles.itemSelected]: !!url,
              })}
              onClick={this.onInsertImageLink}
            >
              <InlineButton
                className={styles.ico}
                iconClassName="icon-custom-link"
              />
            </div>
          </Tooltip>
          <Tooltip text="Replace image">
            <div className={styles.item} onClick={onUploadImage}>
              <InlineButton
                className={styles.ico}
                iconClassName="icon-custom-replace-image"
              />
            </div>
          </Tooltip>
          <Tooltip text="Delete image">
            <div className={styles.item} onClick={onRemoveImage}>
              <InlineButton
                className={styles.ico}
                iconClassName="icon-custom-trash-can"
              />
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  url: getActiveSectionHeaderLogoImageLinkUrl(state),
  sizePreset: getActiveSectionHeaderLogoImageSizePreset(state),
});

const mapDispatchToProps = {
  onUploadImage: openInsertHeaderLogoImageModal,
  onRemoveImage: clearHeaderLogoImage,
  openInsertHeaderLogoLinkModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderImageToolbar);
